import React, { SVGProps } from "react";

const AddItemIcon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element = ({
  height = "24px",
  width = "24px",
  stroke = "black",
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 16.75H5.43C2.74 16.75 1.25 15.27 1.25 12.57V5.43C1.25 2.74 2.73 1.25 5.43 1.25H10C12.69 1.25 14.18 2.73 14.18 5.43C14.18 5.84 13.84 6.18 13.43 6.18C13.02 6.18 12.68 5.84 12.68 5.43C12.68 3.55 11.88 2.75 10 2.75H5.43C3.55 2.75 2.75 3.55 2.75 5.43V12.57C2.75 14.45 3.55 15.25 5.43 15.25H8C8.41 15.25 8.75 15.59 8.75 16C8.75 16.41 8.41 16.75 8 16.75Z"
        fill="currentColor"
      />
      <path
        d="M18.57 22.75H14C11.31 22.75 9.82 21.27 9.82 18.57V11.43C9.82 8.74 11.3 7.25 14 7.25H18.57C21.26 7.25 22.75 8.73 22.75 11.43V18.57C22.75 21.27 21.27 22.75 18.57 22.75ZM14 8.75C12.12 8.75 11.32 9.55 11.32 11.43V18.57C11.32 20.45 12.12 21.25 14 21.25H18.57C20.45 21.25 21.25 20.45 21.25 18.57V11.43C21.25 9.55 20.45 8.75 18.57 8.75H14Z"
        fill="currentColor"
      />
      <path
        d="M18.13 15.75H14.88C14.47 15.75 14.13 15.41 14.13 15C14.13 14.59 14.47 14.25 14.88 14.25H18.13C18.54 14.25 18.88 14.59 18.88 15C18.88 15.41 18.54 15.75 18.13 15.75Z"
        fill="currentColor"
      />
      <path
        d="M16.5 17.38C16.09 17.38 15.75 17.04 15.75 16.63V13.38C15.75 12.97 16.09 12.63 16.5 12.63C16.91 12.63 17.25 12.97 17.25 13.38V16.63C17.25 17.04 16.91 17.38 16.5 17.38Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AddItemIcon;
